import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { TOCListModel } from '../../models/TOCListModel';
import { TOCModel } from '../../models/TOCModel';
import { MatTableDataSource } from '@angular/material/table';
import { RestAPIService } from 'src/app/services/restapi.service';
import { MatDialog } from '@angular/material/dialog';
import { ToastService } from 'src/app/services/toaster.service';
import { PermissionService } from 'src/app/services/permission.service';
import { TocAddEditComponent } from '../add-edit/toc-add-edit.component';
import { environment } from 'src/environments/environment';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ConfirmDialogComponent } from 'src/app/components/confirmation/confirm-dialog.component';
import * as moment from 'moment';

@Component({
  selector: 'app-toc-list',
  templateUrl: './toc-list.component.html',
  styleUrl: './toc-list.component.css'
})
export class TocListComponent {
  public pageSize = 10;
  public currentPage = 0;
  public totalSize = 0;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  tocList: TOCListModel[] = [];
  sortedTOCList: TOCListModel[] = [];
  tocModel: TOCModel = new TOCModel();
  dataSource = new MatTableDataSource<TOCListModel>();
  isAdvanceSearchFilter: boolean = false;
  filterKey: string = '';
  currentSort!: Sort;
  selectedOption: string = '';
  displayedColumns = ['name','code','status','updatedAt', 'action'];
  isWritePermission: boolean = true;
  constructor(public _restAPI: RestAPIService, public dialog: MatDialog, private toast: ToastService, private permissionService: PermissionService){
    this._restAPI.loading  = false;
    if(!this.permissionService.has('trainoperatingcompany.write')){
      this.isWritePermission = false;
      this.displayedColumns = this.displayedColumns.filter(col => col !== 'action');
    }
  }

  ngOnInit() {
    if (localStorage["applyTOCFilterValue"] === 'true') {
        this.getTOCList(localStorage["tocFilterValue"]);
    }
    else {
        this.getTOCList('');
    }
    localStorage["applyTOCFilterValue"] = '';
  }

  onDisplayFilter(e : any) {
    this.isAdvanceSearchFilter = !this.isAdvanceSearchFilter;
    if(e) {
        e.stopPropagation();
    }
  }

  applyFilter(filterValue: string) {
    if (this.dataSource?.paginator) {
        this.dataSource.paginator.pageIndex = 0;
    }
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    localStorage["tocFilterValue"] = filterValue;
    this.dataSource.filter = filterValue;
  }

  applyActiveFilter(){
    this.dataSource.data = this.tocList;
    if(this.selectedOption === '1'){
        this.dataSource.data = this.dataSource.data.filter(x=>x.isActive === true);
    }
    else if(this.selectedOption === '2'){
        this.dataSource.data = this.dataSource.data.filter(x=>x.isActive === false);
    }
  }

  clearFilter(){
    this.selectedOption = '';
    this.filterKey='';
    this.applyActiveFilter();
    this.applyFilter('');
  }

  openTOCDialog(tocModel: TOCModel): void {
    const dialogRef = this.dialog.open(TocAddEditComponent, {
        width:"1024px",
        data:{
            tocModel: tocModel
        } 
    });

    dialogRef.afterClosed().subscribe(result => {
        this.tocModel = new TOCModel();
        if (result) {
            this.getTOCList(localStorage["tocFilterValue"]);
        }
        localStorage["applyTOCFilterValue"] = '';
    });
  }

  async getTOCList(filterValue : any) {
    this._restAPI.loading  = true;
    this._restAPI.get<TOCListModel[]>(environment.apiURL + 'api/trainoperatingcompany/list').subscribe({
        next: (data) => {
            this._restAPI.loading  = false;
            for(let tocObj of data){
                if(!tocObj.updatedOn){
                    tocObj.updatedOn = tocObj.createdOn;
                }
            }
            this.tocList = data;
            this.sortedTOCList = this.tocList.slice();
            this.totalSize = this.sortedTOCList.length;
            this.dataSource.data = data;
            this.dataSource.filter = filterValue;
            this.filterKey = filterValue;
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        },
        error: (error) =>{console.error(error); this._restAPI.loading  = false;}
    });
  }

  sortTOCs(sort: Sort) {
      if (this.dataSource?.paginator) {
          this.dataSource.paginator.pageIndex = 0;
      }
      this.filterKey = "";
      this.currentSort = sort;
      this.pageSize = 10;
      this.currentPage = 0;
      this.sortTOCArray(this.dataSource.data.slice(), this.currentSort);
      this.dataSource.data = this.sortedTOCList;
  }

  onToggleChange(event: MatSlideToggleChange, id: string){
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '500px',
        data: {
          message: `Are you sure you want to ${event.checked ? 'active' : 'inactive'} this train operating company?`
        }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
            console.log('Toggle changed:', event.checked); // true or false

            let postData = {
                trainOperationCompanyId: id,
                isActive: event.checked
              };

            this._restAPI.loading  = true;  
            this._restAPI.put<string>(environment.apiURL + 'api/trainoperatingcompany/activeinactive', postData).subscribe({
                next: (results) => {
                    this._restAPI.loading  = false;
                    dialogRef.close(true);
                    this.toast.show("Train operating company has been updated succussfully");
                },
                error: (error) => {console.error(error);this._restAPI.loading  = false;}
            });
        }
        else{
            event.source.checked = !event.checked;
        }
      });
  }

  private sortTOCArray(tocs: TOCListModel[], sort: Sort): void {
      if (sort === undefined || !sort.active || sort.direction === '') {
          this.sortedTOCList = tocs.slice();
          return;
      }
      this.sortedTOCList = tocs.sort((a, b) => {
          const isAsc = sort.direction === 'asc';
          switch (sort.active) {
              case 'name': return compare(a.name ?? '', b.name ?? '', isAsc);
              case 'code': return compare(a.code ?? '', b.code ?? '', isAsc);
              case 'status': return compare(a.isActive ?? false, b.isActive ?? false, isAsc);
              case 'updatedAt': return compare(a.updatedOn ?? new Date(-8640000000000000), b.updatedOn ?? new Date(-8640000000000000), isAsc);
              default: return 0;
          }
      });

      const part = this.sortedTOCList.slice();
      this.sortedTOCList = [];
      for (const user of part) {
          this.sortedTOCList.push(user);
      }
  }

  private getDate(date : Date | null){
      if(date){
          return moment.utc(date).local().format('YYYY-MM-DD hh:mm A');
      }
      else{
          return null;
      }
  }

  private copyText(text: string, messageHeader: string){
    navigator.clipboard.writeText(text);
    this.toast.show(messageHeader +" copied to clipboard.")
  }
}

function compare(a: number | string | boolean | Date, b: number | string | boolean | Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}